export const eventMutations = {
    STORE_BACKUP(state, model) {
        state.backup = model
    },
}
